import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '../../containers/Full'

import store from '../store'

// Views
import OnBoarding from "../views/unauthenticated/OnBoarding";
import Empty from "../../containers/Empty";

Vue.use(Router)

const router = new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior (to, from, savedPosition) {
        // savedPosition is only available for popstate navigations.
        if (savedPosition) return savedPosition

        // if the returned position is falsy or an empty object,
        // will retain current scroll position.
        if (to.params.savePosition) return {}

        // scroll to anchor by returning the selector
        if (to.hash) {
            return {selector: to.hash}
        }

        // scroll to top by default
        return {x: 0, y: 0}
    },
    routes: [
        {
            path: '/:language_code/customer/guest',
            name: 'UnAuthenticated',
            component: Empty,
            children: [
                {
                    path: 'user-on-boarding',
                    name: 'User OnBoarding',
                    component: OnBoarding,
                },
            ]
        },
        {
            path: '*',
            component: Full,
            beforeEnter: async (to, from, next) => {
                //se l'app non è ancora stata inizializzata
                if (!store.getters.getInit) {
                    store.dispatch('init', laravel);
                    store.dispatch('account/login').then((user) => {
                      // Capture query string from the current route
                      // passing it while redirecting if needed
                      const queryParams = to.query;

                        if(!user.customer) next({name: 'Registration', query: queryParams});
                        else if (!user.customer.initialized) next({ name: 'Wizard' });
                        else store.dispatch('account/fetchPendingDocuments').then((data) => {
                            if (data.length > 0) next({ name: 'ServiceDocumentsSign' });
                            else next(to);
                        });
                    });
                }
            },
            meta: {
                authName: "main",
            }
        },
    ],
});

export default router;
